import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { loadModulePerformanceHeatmapAsync, loadTestPerformanceHeatmapAsync } from '../dashboardSlice';
import { ModulePerformanceHeatmap } from '../components/ModulePerformanceHeatmap';
import { TestPerformanceHeatmap } from '../components/TestPerformanceHeatmap';

const studentDisplayName = (student) => {
    if (!student) return '';
    const name = [student.firstName, student.lastName].filter(Boolean).join(' ');
    return name || student.email;
};

// Acessado pela coluna Detalhamento do grid de Ranking de Alunos — reaproveita
// os mesmos componentes/endpoints dos heatmaps agregados (Módulo e Prova),
// só passando o userId do aluno como filtro. Abas Módulo/Prova, mesmo padrão
// da tela agregada (HeatmapPerformancePage) — cada uma só busca ao ser aberta.
export const StudentHeatmapPage = () => {
    const { id } = useParams();
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const student = location.state?.student ?? null;
    const [activeIndex, setActiveIndex] = useState(0);
    const loadedTabs = useRef(new Set());

    // Diferente do heatmap agregado (HeatmapPerformancePage), aqui não tem
    // filtro de período por default — é a tela de detalhe de UM aluno
    // específico, faz sentido já abrir com o histórico completo dele.
    const tabLoaders = [
        () => dispatch(loadModulePerformanceHeatmapAsync({ userId: id })),
        () => dispatch(loadTestPerformanceHeatmapAsync({ userId: id })),
    ];

    const loadTab = useCallback((index) => {
        loadedTabs.current.add(index);
        tabLoaders[index]?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        loadedTabs.current = new Set();
        loadTab(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <div className="grid p-fluid">
            <div className="col-12">
                <div className="card">
                    <div className="flex align-items-center justify-content-between gap-3 mb-4">
                        <div className="flex align-items-center gap-3">
                            <Button
                                icon="pi pi-arrow-left"
                                rounded
                                text
                                // goBack() (POP) em vez de push('/students-ranking') — é
                                // o que deixa a tabela de ranking (StudentsRankingTable)
                                // saber que isso foi um "voltar" e não uma navegação
                                // nova pelo menu, pra decidir se reaproveita o estado ou
                                // reseta (mesmo padrão de UsersView.js/UserDetailsPage.js
                                // e StudentTimelinePage.js).
                                onClick={() => history.goBack()}
                            />
                            <div>
                                <h5 className="m-0">Heatmap de desempenho — {studentDisplayName(student) || `Aluno ${id}`}</h5>
                                {student && (
                                    <span className="text-color-secondary text-sm">
                                        {[student.serviceName, student.uf].filter(Boolean).join(' — ') || student.email}
                                    </span>
                                )}
                            </div>
                        </div>
                        {/* Único botão de recarregar da página — os cards
                            individuais (showReload={false} abaixo) não têm
                            mais o próprio, pra não duplicar. */}
                        <Button
                            icon="pi pi-refresh"
                            rounded
                            text
                            onClick={() => loadTab(activeIndex)}
                        />
                    </div>

                    <TabView
                        activeIndex={activeIndex}
                        onTabChange={(e) => {
                            setActiveIndex(e.index);
                            if (!loadedTabs.current.has(e.index)) loadTab(e.index);
                        }}
                    >
                        <TabPanel header="Módulo">
                            <ModulePerformanceHeatmap userId={id} showReload={false} />
                        </TabPanel>
                        <TabPanel header="Prova">
                            <TestPerformanceHeatmap userId={id} showReload={false} />
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        </div>
    );
};

export default StudentHeatmapPage;
